
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Icon } from "@/components/ui/icon";

export type ContactDeliverability =
  | "deliverable"
  | "undeliverable"
  | "risk_elevated"
  | "unknown"
  | null
  | undefined;

const TRIGGER_CLASS =
  "-m-2 flex shrink-0 items-center justify-center p-2 sm:m-0 sm:p-0";

export function ContactItemDeliverability({
  deliverability,
  type,
  isValid,
  tooltipClassName,
}: {
  deliverability: ContactDeliverability;
  type: "email" | "phone";
  isValid?: boolean | null;
  /** Extra classes for the tooltip content — e.g. a higher z-index when
   * rendered inside a popover/dropdown so the tip isn't clipped behind it. */
  tooltipClassName?: string;
}) {
  if (type === "phone") {
    if (isValid === true) {
      return (
        <Tooltip>
          <TooltipTrigger className={TRIGGER_CLASS}>
            <Icon name="IconSubscriptionTick1" size={16} className="text-ai" />
          </TooltipTrigger>
          <TooltipContent className={tooltipClassName}>Valid Number</TooltipContent>
        </Tooltip>
      );
    }
    if (isValid === false) {
      return (
        <Tooltip>
          <TooltipTrigger className={TRIGGER_CLASS}>
            <Icon name="IconCircleX" size={16} className="text-destructive" />
          </TooltipTrigger>
          <TooltipContent className={tooltipClassName}>Invalid Number</TooltipContent>
        </Tooltip>
      );
    }
    return null;
  }

  if (deliverability === "deliverable") {
    return (
      <Tooltip>
        <TooltipTrigger className={TRIGGER_CLASS}>
          <Icon name="IconSubscriptionTick1" size={16} className="text-ai" />
        </TooltipTrigger>
        <TooltipContent className={tooltipClassName}>Delivery Verified</TooltipContent>
      </Tooltip>
    );
  }

  if (deliverability === "undeliverable") {
    return (
      <Tooltip>
        <TooltipTrigger className={TRIGGER_CLASS}>
          <Icon name="IconCircleX" size={16} className="text-destructive" />
        </TooltipTrigger>
        <TooltipContent className={tooltipClassName}>Undeliverable</TooltipContent>
      </Tooltip>
    );
  }

  if (deliverability === "risk_elevated") {
    return (
      <Tooltip>
        <TooltipTrigger className={TRIGGER_CLASS}>
          <Icon name="IconExclamationCircle" size={16} className="text-yellow-500" />
        </TooltipTrigger>
        <TooltipContent className={tooltipClassName}>Risky</TooltipContent>
      </Tooltip>
    );
  }

  if (deliverability === "unknown") {
    return (
      <Tooltip>
        <TooltipTrigger className={TRIGGER_CLASS}>
          <Icon name="IconQuestionmarkCircle2" size={16} className="text-muted-foreground" />
        </TooltipTrigger>
        <TooltipContent className={tooltipClassName}>Unknown</TooltipContent>
      </Tooltip>
    );
  }

  return null;
}
